<div class="ul-page">

  <div class="ul-header">
    <mat-icon svgIcon="church-group" class="ul-header-icon"></mat-icon>
    <div class="ul-header-text">
      <h2 class="ul-title">Comunidades</h2>
      <p class="ul-subtitle">Accede a todas las comunidades</p>
    </div>
  </div>

  <mat-card class="table-surface-card">
    <mat-card-content>
      <app-table-surface
        title="Comunidades"
        titleIcon="church"
        [columns]="columns"
        [data]="tableData"
        [isLoading]="isTableLoading"
        [errorMessage]="tableErrorMessage"
        [paginationConfig]="paginationConfig"
        [showPageSizeSelector]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [multiSort]="true"
        [noDataMessage]="'No se encontraron comunidades con los filtros seleccionados.'"
        [cellTemplate]="cellContent"
        [activeFilters]="activeFilterChips"
        tableId="unit-list"
        [enableSearch]="true"
        searchPlaceholder="Buscar comunidad..."
        [enableFilter]="true"
        [enableColumnVisibility]="true"
        [enableDensity]="true"
        [exportFileName]="'comunidades.csv'"
        primaryActionLabel="Nuevo"
        [readonly]="!canManageCommunityData"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (sortChange)="onSortChange($event.sortBy)"
        (searchChange)="onToolbarSearch($event)"
        (filterRemove)="onFilterRemove($event)"
        (rowClick)="navigateToUnit($event.id)"
        (primaryActionClick)="createNew()">

        <div filterPanel [formGroup]="filterForm" class="unit-filter-panel">
          <app-autocomplete
            label="Area Apostol"
            placeholder="Buscar area..."
            [options]="(areas$ | async) || []"
            [selectedValue]="filterForm.get('selectedArea')?.value"
            (selectionChanged)="onAreaChanged($event)">
          </app-autocomplete>

          <app-autocomplete
            label="Distrito"
            placeholder="Buscar distrito..."
            [options]="(filteredDistricts$ | async) || []"
            [selectedValue]="filterForm.get('selectedDistrict')?.value"
            (selectionChanged)="onDistrictChanged($event)">
          </app-autocomplete>

          <app-autocomplete
            label="Grupo de Comunidad"
            placeholder="Buscar grupo..."
            [options]="(filteredCommunityGroups$ | async) || []"
            [selectedValue]="filterForm.get('selectedGroup')?.value"
            (selectionChanged)="onGroupChanged($event)">
          </app-autocomplete>

        </div>
      </app-table-surface>

      <div *ngIf="(error$ | async) as error" class="error-container">
        <mat-icon>error</mat-icon>
        <p>{{ error }}</p>
      </div>

      <ng-template #cellContent let-column="column" let-row="row">
        <div *ngIf="column === 'name'" [class.inactive]="row.isActive === false">
          <a (click)="navigateToUnit(row.id)">{{ row.name }}</a>
        </div>

        <div *ngIf="column === 'group'">
          <ng-container *ngIf="getGroupId(row) as groupId; else noGroupLink">
            <a (click)="navigateToUnit(groupId)">{{ getGroupName(row) }}</a>
          </ng-container>
          <ng-template #noGroupLink>{{ getGroupName(row) }}</ng-template>
        </div>

        <div *ngIf="column === 'district'">
          <ng-container *ngIf="getDistrictId(row) as districtId; else noDistrictLink">
            <a (click)="navigateToUnit(districtId)">{{ getDistrictName(row) }}</a>
          </ng-container>
          <ng-template #noDistrictLink>{{ getDistrictName(row) }}</ng-template>
        </div>

        <div *ngIf="column === 'area'">
          <ng-container *ngIf="getAreaId(row) as areaId; else noAreaLink">
            <a (click)="navigateToUnit(areaId)">{{ getAreaName(row) }}</a>
          </ng-container>
          <ng-template #noAreaLink>{{ getAreaName(row) }}</ng-template>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>

</div>
